import { makeAutoObservable } from "mobx";

import { Device } from "./BreakpointStore";

export class SidebarStore {
  private overlaySidebarVisible: boolean = false;
  private collapsed: boolean = false;

  private _isAnonymous: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  public get isAnonymous(): boolean {
    return this._isAnonymous;
  }

  public setIsAnonymous(value: boolean) {
    this._isAnonymous = value;
  }

  public get isOverlaySidebarVisible() {
    return this.overlaySidebarVisible;
  }

  public setOverlaySidebarVisible = (visible: boolean) => {
    this.overlaySidebarVisible = visible;
  };

  public get isCollapsed() {
    return this.collapsed;
  }

  public isOverlaySidebar = (device: Device): boolean => {
    return device === Device.Mobile || device === Device.Tablet;
  };

  public setIsCollapsed = (collapsed: boolean) => {
    this.collapsed = collapsed;
  };
}
